import { Fragment } from "react";
import { Col, Row } from "reactstrap";
import { H3 } from "../../../AbstractElements";
import { QuickQuestions } from "../../../Constant";
import { FAQ_QUESTIONS_DATA } from "../../../Data/Faq";
import AccordionCard from "../Common/AccordionCard";
import FaqRightsidebar from "./FaqRightside";

const Questions = () => {
  return (
    <Col lg="12">
      <div className="header-faq">
        <H3 className="mb-0">{QuickQuestions}</H3>
      </div>
      <Row className="default-according style-1 faq-accordion">
        <Col xl="8" lg="6" md="7" className="xl-60">
          {FAQ_QUESTIONS_DATA.map((item, i) => (
            <Fragment key={i}>
              {item.subTitle && (
                <div className="faq-title">
                  <H3>{item.subTitle}</H3>
                </div>
              )}
              {FAQ_QUESTIONS_DATA[i].titles.map((item, id) => (
                <AccordionCard key={id} item={item} />
              ))}
            </Fragment>
          ))}
        </Col>
        <FaqRightsidebar />
      </Row>
    </Col>
  );
};
export default Questions;
